/** 控件类型: 签名/印章/日期/文本/复选框/附件... */
export enum WidgetType {
  /** 未知 */
  UNKNOWN = -1,

  /**
   * 签署控件
   */

  /** 签名 */
  SIGNATURE = 0,

  /** 印章 */
  SEAL = 1,

  /** 日期签署 */
  DATE = 2,

  /** 签署备注 */
  REMARK = 15,

  /**
   * 填写控件
   */

  /** 单行文本 */
  INPUT = 3,

  /** 多行文本 */
  TEXTAREA = 4,

  /** 复选框 */
  CHECKBOX = 5,

  /** 附件 */
  ATTACHMENT = 6,

  /** API 旧的表格，暂不支持 */
  TABLE_API3 = 7,

  /** 图片 */
  IMAGE = 8,

  /** 数字 */
  NUMBER = 9,

  /** 身份证号 */
  ID = 10,

  /** 日期填写 */
  DATE_FILL = 11,

  /** 单选框 */
  RADIO_GROUP = 12,

  /** 复选框 */
  CHECKBOX_GROUP = 13,

  /** 下拉选择 */
  SELECT = 14,

  /** 表格 */
  TABLE = 16
}
